<template>
  <main-layout>
    <div id="upgrade_plan" style="padding: 25px 25px;">
      <div class="row">
        <div class="col s12">
          <h4
            v-if="currentLang == 'la' && $store.getters.getPackage == 'premium'"
            class="text-xs-center"
          >
            ທ່ານກຳລັງໃຊ້ Premium Package
          </h4>
          <h4 v-else class="text-xs-center">{{ $t('Facebook Chatbot Package') }}</h4>
          <view-package></view-package>

          <p class="text-xs-center">
            {{ $t('** Note: User can install Chatbot only 1 page per Premium Package') }}
          </p>
          <p class="text-xs-center primary-color">
            {{
              $t(
                'To customize any feature or require a quotation for Chatbot, please contact Email:'
              )
            }}
            <a href="mailto:sales@zwiz.ai">sales@zwiz.ai</a>
          </p>
          <p class="text-xs-center">
            {{ $t('If you want to purchase more than 1 page,') }}
            <a
              href="https://blog.zwiz.ai/promotion-ซื้อมากกว่า-1-page/"
              target="_blank"
              rel="noopener noreferrer"
              >{{ $t('click here') }}</a
            >
          </p>
        </div>
      </div>
    </div>
    <div class="hr"></div>
    <div class="pb-4 text-xs-center">
      <v-container>
        <h4>{{ $t('Support2') }}</h4>
        <support-code @updateSupportCode="onUpdateSupportCode"></support-code>
      </v-container>
    </div>
    <div class="hr"></div>
    <div style="padding: 25px 25px;">
      <div class="row">
        <div class="col s12">
          <h4 class="text-xs-center" style="margin-bottom: 25px">{{ $t('Premium Features') }}</h4>
          <div style="border: 1px solid #eee; border-radius: 10px;margin-top: 15px;overflow:hidden">
            <table class="striped">
              <thead>
                <tr>
                  <th class="text-xs-center" style="font-size: 1.3em;width: 0">
                    {{ $t('Features') }}
                  </th>
                  <th class="text-xs-center" style="font-size: 1.3em;">{{ $t('Basic') }}</th>
                  <th class="text-xs-center" style="font-size: 1.3em;">{{ $t('premium') }}</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td class="text-xs-center" style="width: 350px">{{ $t('Welcome Message') }}</td>
                  <td class="text-xs-center">
                    <i class="fas fa-check" style="color: #90db26"></i>
                  </td>
                  <td class="text-xs-center">
                    <i class="fas fa-check" style="color: #90db26"></i>
                  </td>
                </tr>
                <!-- <tr>
                                <td class="text-xs-center">{{$t('Extra Menu')}}</td>
                                <td class="text-xs-center"><i class="fas fa-check" style="color: #90db26"></i></td>
                                <td class="text-xs-center"><i class="fas fa-check" style="color: #90db26"></i></td>
                </tr>-->
                <tr>
                  <td class="text-xs-center">{{ $t('Real-time Response') }}</td>
                  <td class="text-xs-center">{{ $t('Unlimited') }}</td>
                  <td class="text-xs-center">{{ $t('Unlimited') }}</td>
                </tr>
                <tr>
                  <td class="text-xs-center">{{ $t('Typing Time') }}</td>
                  <td class="text-xs-center">
                    <i class="fas fa-check" style="color: #90db26"></i>
                  </td>
                  <td class="text-xs-center">
                    <i class="fas fa-check" style="color: #90db26"></i>
                  </td>
                </tr>
                <tr>
                  <td class="text-xs-center">{{ $t('Advance Conversation') }}</td>
                  <td class="text-xs-center">
                    <i class="fas fa-times" style="color: red"></i>
                  </td>
                  <td class="text-xs-center">
                    <i class="fas fa-check" style="color: #90db26"></i>
                  </td>
                </tr>
                <tr>
                  <td class="text-xs-center">
                    {{ $t('Status') + ' ' + $t('and') + ' ' + $t('Tag') }}
                  </td>
                  <td class="text-xs-center">
                    <i class="fas fa-times" style="color: red"></i>
                  </td>
                  <td class="text-xs-center">
                    <i class="fas fa-check" style="color: #90db26"></i>
                  </td>
                </tr>
                <tr>
                  <td class="text-xs-center">{{ $t('AI Training') }}</td>
                  <td class="text-xs-center">
                    <i class="fas fa-times" style="color: red"></i>
                  </td>
                  <td class="text-xs-center">
                    <i class="fas fa-check" style="color: #90db26"></i>
                  </td>
                </tr>
                <tr>
                  <td class="text-xs-center">{{ $t('Reply to comment') }}</td>
                  <td class="text-xs-center">{{ $t('All Post') }}</td>
                  <td class="text-xs-center">{{ $t('Selected Post, All Post') }}</td>
                </tr>
                <tr>
                  <td class="text-xs-center">{{ $t('Comment to Inbox Upgrade') }}</td>
                  <td class="text-xs-center">{{ $t('All Post') }}</td>
                  <td class="text-xs-center">{{ $t('Selected Post, All Post') }}</td>
                </tr>
                <tr>
                  <td class="text-xs-center">{{ $t('Hide comment') }}</td>
                  <td class="text-xs-center">{{ $t('All Post') }}</td>
                  <td class="text-xs-center">{{ $t('Selected Post, All Post') }}</td>
                </tr>
                <tr>
                  <td class="text-xs-center">{{ $t('Broadcast') }}</td>
                  <td class="text-xs-center">{{ $t('Unlimited') }} ({{ $t('Basic') }})</td>
                  <td class="text-xs-center">{{ $t('Unlimited') }} ({{ $t('Customize_2') }})</td>
                </tr>
                <tr>
                  <td class="text-xs-center">{{ $t('Shop Service') }}</td>
                  <td class="text-xs-center">{{ $t('10 Products') }}</td>
                  <td class="text-xs-center">{{ $t('Unlimited') }}</td>
                </tr>
                <tr>
                  <td class="text-xs-center">{{ $t('Wholesale System') }}</td>
                  <td class="text-xs-center">
                    <i class="fas fa-times" style="color: red"></i>
                  </td>
                  <td class="text-xs-center">
                    <i class="fas fa-check" style="color: #90db26"></i>
                  </td>
                </tr>
                <tr>
                  <td class="text-xs-center">{{ $t('In-Chat Payment') }}</td>
                  <td class="text-xs-center">
                    <i class="fas fa-check" style="color: #90db26"></i>
                  </td>
                  <td class="text-xs-center">
                    <i class="fas fa-check" style="color: #90db26"></i>
                  </td>
                </tr>
                <tr>
                  <td class="text-xs-center">{{ $t('Chat log Analytics') }}</td>
                  <td class="text-xs-center">{{ $t('Basic') }}</td>
                  <td class="text-xs-center">{{ $t('Customize_2') }}</td>
                </tr>
                <tr>
                  <td class="text-xs-center">{{ $t('Advanced CRM') }}</td>
                  <td class="text-xs-center">{{ $t('Basic') }}</td>
                  <td class="text-xs-center">{{ $t('Customize_2') }}</td>
                </tr>
                <tr>
                  <td class="text-xs-center">{{ $t('Export Analytics') }}</td>
                  <td class="text-xs-center">
                    <i class="fas fa-times" style="color: red"></i>
                  </td>
                  <td class="text-xs-center">
                    <i class="fas fa-check" style="color: #90db26"></i>
                  </td>
                </tr>
                <tr>
                  <td class="text-xs-center">{{ $t('Languages') }}</td>
                  <td class="text-xs-center">{{ $t('TH/ENG') }}</td>
                  <td class="text-xs-center">{{ $t('All languages') }}</td>
                </tr>
                <!-- <tr>
                                <td class="text-xs-center">{{$t('LINE Notification')}}</td>
                                <td class="text-xs-center"><i class="fas fa-times" style="color: red"></i></td>
                                <td class="text-xs-center"><i class="fas fa-check" style="color: #90db26"></i></td>
                </tr>-->
                <tr>
                  <td class="text-xs-center">{{ $t('Support') }}</td>
                  <td class="text-xs-center">{{ $t('Queue') }}</td>
                  <td class="text-xs-center">{{ $t('Priority') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import ViewPackage from '@/components/view/setting/ViewPackage'
import SupportCode from './SupportCode'
import { mapGetters } from 'vuex'

export default {
  components: {
    ViewPackage,
    SupportCode
  },
  computed: {
    ...mapGetters(['currentLang'])
  },
  methods: {
    onUpdateSupportCode: function() {
      location.reload()
    }
  }
}
</script>

<style lang="scss">
.zoid-outlet {
  z-index: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/billing/Upgrade.vue